import {Metric} from 'app_api/projects/metrics/types';
import {useMetrics} from 'common/contexts/react/metrics-resource-context';
import {Translatable} from 'common/i18n';

import {FormulaSectionItem, MenuType, MultiMetricsSection} from '../multi-metrics-menu/types';
import {FormulaMenuItemValue} from './types';

function getFormulaMenuItem(metric: Metric): FormulaSectionItem {
  return {
    icon: `formula`,
    label: metric.name,
    menuType: MenuType.Formula,
    value: {
      id: metric.id,
    },
  };
}

export function getFormulaSection({
  label,
  savedFormulas,
  isRecentSection = false,
}: {
  label: Translatable;
  savedFormulas: Metric[];
  isRecentSection?: boolean;
}): MultiMetricsSection<FormulaMenuItemValue> {
  return {
    label,
    isRecentSection,
    items: savedFormulas.map(getFormulaMenuItem),
  };
}

export function getFormulaSections({
  recentFormulaMenuItems,
  savedFormulas,
}: {
  recentFormulaMenuItems: FormulaMenuItemValue[];
  savedFormulas: Metric[];
}): Array<MultiMetricsSection<FormulaMenuItemValue>> {
  if (savedFormulas.length) {
    const recentFormulas = savedFormulas.filter((formula) =>
      recentFormulaMenuItems.some((item) => item.id === formula.id),
    );

    const showRecents = savedFormulas.length > 6 && recentFormulas.length > 0;
    return [
      /** only disply a recently used section when there are enough items to fill in the dropdown */
      getFormulaSection({
        label: ({t}) => t(`query-builder.multi-metrics-menu.section-recents`),
        savedFormulas: showRecents ? recentFormulas : [],
        isRecentSection: true,
      }),
      getFormulaSection({
        label: showRecents ? ({t}) => t(`query-builder.multi-metrics-menu.section-formulas`) : ``,
        savedFormulas,
      }),
    ].filter(Boolean);
  }
  return [];
}

export function useSavedFormulas(): Metric[] {
  const metrics = useMetrics();
  return metrics.getAllValues().filter((metric) => metric.type === `formula` && metric.can_view);
}
